export default {
    "h0": {
        variant: "subtitle1",
        rowHeight: 25
    },
    "d0": {
        variant: "caption",
        rowHeight: 30
    },
    "eol": {
        variant: "caption",
        rowHeight: 20
    }
}